// ============================================================
// JINS NEW CLASSIC 26SS — Lookbook JS
// Page: /pages/new-classic-lookbook-26ss
// ============================================================

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('#jins-new-classic-lookbook-26ss');
  if (!root) return;

  var cdn = 'https://cdn.shopify.com/s/files/1/0562/8903/4283/files/';

  // ============================================================
  // LOOK MODAL DATA
  // Maps each look ID to product info
  // TODO: Fill all US PDP URLs before launch
  // ============================================================
  var lookData = {
    'is-7-1': {
      sku:   'UTF-26S-130',
      color: '296',
      price: '$390',
      img:   cdn + 'newclassic-product-UTF-26S-130_296.webp',
      url:   'https://us.jins.com/products/jins-new-classic-made-in-japan-130'
    },
    'is-7-2': {
      sku:   'UTF-26S-130',
      color: '184',
      price: '$390',
      img:   cdn + 'newclassic-product-UTF-26S-130_184.webp',
      url:   'https://us.jins.com/products/jins-new-classic-made-in-japan-130-184'
    },
    'is-7-3': {
      sku:   'UTF-26S-133',
      color: '194',
      price: '$390',
      img:   cdn + 'newclassic-product-UTF-26S-133_194.webp',
      url:   'https://us.jins.com/products/jins-new-classic-made-in-japan-sg-133'
    },
    'is-8-1': {
      sku:   'UCF-26S-131',
      color: '294',
      price: '$390',
      img:   cdn + 'newclassic-product-UCF-26S-131_294.webp',
      url:   'https://us.jins.com/products/jins-new-classic-made-in-japan-131'
    },
    'is-8-2': {
      sku:   'UCF-26S-131',
      color: '186',
      price: '$390',
      img:   cdn + 'newclassic-product-UCF-26S-131_186.webp',
      url:   'https://us.jins.com/products/jins-new-classic-made-in-japan-131-186'
    },
    'is-8-3': {
      sku:   'UCF-26S-134',
      color: '192',
      price: '$390',
      img:   cdn + 'newclassic-product-UCF-26S-134_192.webp',
      url:   'https://us.jins.com/products/jins-new-classic-made-in-japan-sg-134'
    },
    'is-9-1': {
      sku:   'UCF-26S-132',
      color: '294',
      price: '$390',
      img:   cdn + 'newclassic-product-UCF-26S-132_294.webp',
      url:   'https://us.jins.com/products/jins-new-classic-made-in-japan-132'
    },
    'is-9-2': {
      sku:   'UCF-26S-132',
      color: '184',
      price: '$390',
      img:   cdn + 'newclassic-product-UCF-26S-132_184.webp',
      url:   'https://us.jins.com/products/jins-new-classic-made-in-japan-132-184'
    },
    'is-9-3': {
      sku:   'UCF-26S-135',
      color: '198',
      price: '$390',
      img:   cdn + 'newclassic-product-UCF-26S-135_198.webp',
      url:   'https://us.jins.com/products/jins-new-classic-made-in-japan-sg-135'
    }
  };


  // ============================================================
  // MODAL
  // ============================================================
  var modal      = document.getElementById('jt-nclb-modal');
  var closeBtn   = root.querySelector('.jt-nclb-modal__btn-close');
  var modalImg   = root.querySelector('.js-nclb-modal-img');
  var modalSku   = root.querySelector('.js-nclb-modal-sku');
  var modalPrice = root.querySelector('.js-nclb-modal-price');
  var modalLink  = root.querySelector('.js-nclb-modal-link');

  if (!modal) return;

  function jtNclbOpenModal(lookId) {
    var data = lookData[lookId];
    if (!data) return;

    modalSku.textContent   = data.sku + ' — ' + data.color;
    modalPrice.textContent = data.price;
    modalImg.src           = data.img;
    modalImg.alt           = data.sku + ' color ' + data.color;
    modalLink.href         = data.url;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function jtNclbCloseModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Open on look image click
  root.querySelectorAll('.js-nclb-modal-open').forEach(function (el) {
    el.addEventListener('click', function () {
      jtNclbOpenModal(this.dataset.lookId);
    });
  });

  // Close on overlay or close button
  root.querySelectorAll('.js-nclb-modal-close').forEach(function (el) {
    el.addEventListener('click', jtNclbCloseModal);
  });
  closeBtn.addEventListener('click', jtNclbCloseModal);

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      jtNclbCloseModal();
    }
  });


  // ============================================================
  // INVIEW — Fade-in on scroll
  // ============================================================
  function jtNclbInitInview() {
    var els = root.querySelectorAll('.inview');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -150px 0px' });

    els.forEach(function (el) { observer.observe(el); });

    // Safety fallback — force visible after 2s
    setTimeout(function () {
      root.querySelectorAll('.inview:not(.is-inview)').forEach(function (el) {
        el.classList.add('is-inview');
      });
    }, 5000);
  }

  jtNclbInitInview();

  // ============================================================
  // CUSTOM CURSOR — editorial dot + follower, desktop only
  // ============================================================
  function jtNclbInitCustomCursor() {
    if (window.matchMedia('(max-width: 767px)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    var cursor   = document.getElementById('jt-nclb-cursor');
    var follower = document.getElementById('jt-nclb-cursor-follower');
    if (!cursor) return;

    var mouseX = -200, mouseY = -200;
    var followerX = -200, followerY = -200;

    document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.left = mouseX + 'px';
      cursor.style.top  = mouseY + 'px';
    });

    function animateFollower() {
      followerX += (mouseX - followerX) * 0.12;
      followerY += (mouseY - followerY) * 0.12;
      if (follower) {
        follower.style.left = followerX + 'px';
        follower.style.top  = followerY + 'px';
      }
      requestAnimationFrame(animateFollower);
    }
    animateFollower();

    var hoverSelectors = [
      '.jt-nclb-grid__col-a',
      '.jt-nclb-footer-kv'
    ].join(', ');

    document.addEventListener('pointerover', function (e) {
      if (e.target.closest(hoverSelectors)) {
        cursor.classList.add('is-active');
      }
    });

    document.addEventListener('pointerout', function (e) {
      if (e.target.closest(hoverSelectors)) {
        cursor.classList.remove('is-active');
      }
    });

    document.addEventListener('mouseleave', function () {
      cursor.style.opacity = '0';
      follower.style.opacity = '0';
    });
    document.addEventListener('mouseenter', function () {
      cursor.style.opacity = '';
      follower.style.opacity = '';
    });
  }

  jtNclbInitCustomCursor();

});
